import { create } from 'zustand';

interface IntegrationDiagnosticsState {
  lastApiError: string | null;
  lastGrpcError: string | null;
  setLastApiError: (value: string | null) => void;
  setLastGrpcError: (value: string | null) => void;
  clear: () => void;
}

export const useIntegrationDiagnosticsStore = create<IntegrationDiagnosticsState>((set) => ({
  lastApiError: null,
  lastGrpcError: null,
  setLastApiError: (value) => set({ lastApiError: value }),
  setLastGrpcError: (value) => set({ lastGrpcError: value }),
  clear: () => set({ lastApiError: null, lastGrpcError: null }),
}));

